import { render, staticRenderFns } from "./LogImportsTable.vue?vue&type=template&id=ef6d7a24&"
import script from "./LogImportsTable.vue?vue&type=script&lang=js&"
export * from "./LogImportsTable.vue?vue&type=script&lang=js&"
import style0 from "./LogImportsTable.vue?vue&type=style&index=0&id=ef6d7a24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports